export const ABORT = Symbol('FLEX_OPERATE_ABORT')
export const SKIP = Symbol('FLEX_OPERATE_SKIP')
